import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, OnDestroy, OnInit, Output, ViewChild } from "@angular/core";
import { NgbModal, NgbPopover, NgbPopoverConfig } from "@ng-bootstrap/ng-bootstrap";
import { BaseSiteService, GlobalMessageService, GlobalMessageType, RoutingService } from "@spartacus/core";
import { ProductListComponentService, SearchBoxComponentService, SearchBoxConfig } from "@spartacus/storefront";
import { UserAccountFacade } from "@spartacus/user/account/root";
import { Subscription } from "rxjs";
import { take } from "rxjs/operators";
import { AccountOverviewService } from "src/app/account-overview/account-overview.service";
import { CustomAddToCartService } from "src/app/custom-add-to-cart/custom-add-to-cart.service";
import { CustomProdPgService } from "src/app/custom-prod-pg/custom-prod-pg.service";
import { SharedService } from "src/app/shared/services/shared.service";
import { ProductUtils } from "src/app/shared/utils/productUtils";
import * as _ from 'underscore';
import { LoactionStripService } from "../../location-strip/loaction-strip.service";
import { RestrictionPopupComponent } from "../../restriction-popup/restriction-popup.component";
// import { ActiveCartService } from "@spartacus/cart/base/core";
import { DataLayerService } from "src/app/shared/services/data-layer.service";


@Component({
  selector: 'app-quick-order',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './quick-order.component.html',
  styleUrls: ['./quick-order.component.scss'],
})
// userAccountIdDetailsData
export class QuickOrderComponent implements OnInit, OnDestroy {
  @Output() selectedProductEvent = new EventEmitter<any>();
  quickOrderDetails = false;
  clearSearch = false;
  productInfo: any;
  buttonName: string;
  itemAddedQuantity: any;
  userDetails: any;
  cartId: any;
  cartItems: any;
  QUICKORDER_SEARCH_BOX_CONFIG: SearchBoxConfig = {
    minCharactersBeforeRequest: 3,
    displayProducts: true,
    displaySuggestions: false,
    displayProductImages: false,
  };
  clearSearchValue = false;
  userDataSub: Subscription;
  allCartsSub: Subscription;
  createdCartSub: Subscription;
  updatedCartSub: Subscription;
  updatedCartDetailsSub: Subscription;
  @ViewChild('p2') public successPopover: NgbPopover;
  prodListSub: Subscription;
  selectedLocations: any;
  priceDetails: any;
  isLocationSelected: any;
  selectedContractGroup: any;
  contractGroups = []
  baseSiteId: string;
  isGovtCustomer = false; // by default this is false, to be update in ngOnInit based on b2bunitid
  isGovtLocationSelected = false; // by default this is false, to be update in ngOnInit based on selected locations
  locationListSub: Subscription;

  blockOrder: any;
  futureShipProducts = [];
  updateErrorSub: Subscription;
  //  //After upgrade ActiveCartService causing - NullInjectorError: R3InjectorError(AppModule)[ActiveCartService -> ActiveCartService -> ActiveCartService]
  // dont add back ActiveCartService
  constructor(
    private readonly user: UserAccountFacade,
    private readonly config: NgbPopoverConfig,
    private modal: NgbModal,
    // private readonly getCartId: ActiveCartService,
    private readonly route: RoutingService,
    private readonly plpService: CustomProdPgService,
    protected searchBoxComponentService: SearchBoxComponentService,
    private readonly addToCartService: CustomAddToCartService,
    private readonly accService: AccountOverviewService,
    private locStripService: LoactionStripService,
    private readonly productListService: ProductListComponentService,
    private cd: ChangeDetectorRef,
    private baseSiteService: BaseSiteService,
    private readonly sharedService: SharedService,
    private globalMessage: GlobalMessageService,
    private _dataService: DataLayerService
  ) { }
  locationDetails: {};
  ngOnInit(): void {
    this.baseSiteService.getActive().pipe(take(1)).subscribe((res) => (this.baseSiteId = res));

    if (this.productInfo?.flu === true && this.productInfo?.shipNow === "OFF") {
      this.buttonName = 'Reserve';
    } else {
      this.buttonName = 'Add to Cart';
    }
    this.accService.userAccountIdDetailsData.pipe(take(1)).subscribe(res => this.locationDetails = res.defaultB2BUnit);
    this.userDataSub = this.user.get().subscribe((res) => {
      this.userDetails = res;
      if (res !== undefined) {
        if (this.productInfo?.flu === true && this.productInfo?.shipNow === "OFF") {
          this.buttonName = 'Reserve';
        } else {
          this.buttonName = 'Add to Cart';
        }
      } else {
        this.buttonName = 'Login to order';
      }
    });
    this.allCartsSub = this.addToCartService.allCartItems$.subscribe((res) => {
      if (res) {
        this.cartItems = res?.carts;
        this.cartItems = this.cartItems?.filter((item) => item?.saveTime === undefined);
      }
    });
  }

  addToCart(idData, productCode): void {
    //futureship products
    this.futureShipProducts = JSON.parse(this.sharedService.getLocalStorage('futureShipProducts'));
    this.clearSearchValue = false;
    if (this.buttonName === 'Reserve') {
      this.navToReservenow();
    } else if (this.buttonName === 'Add to Cart') {
      const inputElement = document.getElementById(
        `prodQuantityQuick${productCode}`
      ) as HTMLInputElement;
      // const params = {
      //   product: {
      //     code: productCode,
      //   },
      //   quantity: inputElement?.value,
      // };

      let obj_dL_temp = {
        "item_id": productCode,
        "item_name": this.baseProductName,
        "affiliation": this.baseSiteId === 'vsh' ? 'vaccineshoppe.com' : 'vaxserve.com',
        "currency": this.priceDetails.hasOwnProperty('conditions') ? this.priceDetails?.conditions[0]?.contractPrice?.currencyIso : 'USD',
        "coupon": "",
        "item_brand": this.productInfo?.manufacturer,
        "item_category": this.productInfo?.hasOwnProperty('categoryNameList') ? this.productInfo?.categoryNameList[0] : '',
        "item_category2": this.productInfo?.hasOwnProperty('categoryNameList') ? this.productInfo?.categoryNameList[1] : '',
        "item_variant": this.productInfo?.description,
        "price": this.priceDetails.hasOwnProperty('conditions') ? this.priceDetails?.conditions[0]?.contractPrice?.value : 0,
        "quantity": inputElement?.value,
      }
      for (var i = 0; i < this.selectedLocations.length; i++) {
        if (obj_dL_temp.item_name != undefined) {
          this._dataService.addtoDataLayer('add_to_cart_Orders', obj_dL_temp, this.selectedLocations[i].accountNumber, this.selectedLocations);
        }
      }

      let params
      if (this.selectedLocations.length === 1) {
        params = {
          basePrice: { value: this.priceDetails?.price?.value.toString() },
          product: { code: productCode },
          quantity: inputElement?.value,
          selectedLocations: [this.selectedLocations[0]?.accountNumber],
          contractInfo: { contractId: "", contractDesc: "", contractPrice: { value: 0 } }
        }
        if (this.priceDetails.conditions !== undefined) {
          params.contractInfo = this.selectedContractGroup;
          params.basePrice = { value: "0" }
        }
      } else {
        params = {
          basePrice: { value: "0" },
          product: { code: productCode },
          quantity: inputElement?.value,
          selectedLocations: [],
          contractInfo: { contractId: "", contractDesc: "", contractPrice: { value: 0 } }
        }
        this.selectedLocations.forEach(element => {
          params.selectedLocations.push(element.accountNumber)
        });
      }
      this.itemAddedQuantity = inputElement?.value;

      //futureship Flag
      let isFutureshipProduct = this.futureShipProducts?.some((item) => {
        return item == productCode;
      });
      if (isFutureshipProduct)
        params['futureShipExpProd'] = true;

      if (this.cartItems && this.cartItems?.length === 0) {
        this.plpService.createCart(this.userDetails?.uid);
        this.createdCartSub = this.plpService.createdCart$.subscribe((res) => {
          if (res) {
            this.cartId = res?.code;
            this.addToCartService.getAllCarts(this.userDetails?.uid);
            this.plpService.updateCart(params, this.userDetails?.uid, this.cartId, this.productInfo);
            this.updatedCartSub = this.plpService.cartDetailsUpdate$.subscribe((resp) => {
              if (resp) {
                this.successPopover.open();
                setTimeout(() => this.successPopover.toggle(), 2500);
                if (params.hasOwnProperty('futureShipExpProd') && !this.sharedService.getLocalStorage('implicitOptIn') &&
                  !this.sharedService.getLocalStorage('futureshipModalOpened'))
                  this.sharedService.setLocalStorage('futureshipAction', 'addtocart');
              }
            });
          }
        });
      } else {
        if (this.cartId === undefined) {
          this.cartItems = this.cartItems && this.cartItems?.length > 0 ? this.cartItems[this.cartItems?.length - 1] : [];
          this.cartId = this.cartItems?.code;
        }
        this.plpService.updateCart(params, this.userDetails?.uid, this.cartId, this.productInfo);

        this.updatedCartDetailsSub = this.plpService.cartDetailsUpdate$.subscribe((res) => {
          if (res) {
            this.successPopover.open();
            setTimeout(() => { this.successPopover.toggle(); window.location.reload() }, 2500);
            this.clearSearch = true;
          }
        });
      }
    } else if (this.buttonName === 'Select a location to order') {
      this.locStripService.openModal.next(true);
    }
    this.updateErrorSub = this.plpService.updateError$.subscribe((res) => {
      if (res) {
        this.globalMessage.add(res?.error?.errors[0]?.message,
          GlobalMessageType.MSG_TYPE_ERROR,
          500000
        );
        window.scroll({ top: 0, behavior: 'smooth' });
      }
    })
  }
  ngDoCheck() {
    if (!this.successPopover?.isOpen() && this.clearSearch) {
      this.quickOrderDetails = false;
      this.clearSearch = false;
      this.clearSearchValue = true;
    }
  }
  navToReservenow() {
    this.route.goByUrl('/influenza/dashboard');
  }

  // unitCount = 1;
  performQuantityComputationQuick(operator, idData): void {
    ProductUtils.computeQuantityForAllocatedQuickAdd(operator, idData, this.productInfo.quantityPerUnit,
      this.productInfo.uom, +this.productInfo.allocationInfos?.availableQty);
  }
  // addtoFluCart() {
  //   this.route.goByUrl('/influenza/category');
  // }

  baseProductName: string;
  nonFormularyProduct = false;
  noYFRestriction = true;
  onProductSelected(product) {
    this.blockOrder = this.sharedService.getLocalStorage('blockOrder');
    this.isGovtCustomer = this.sharedService.getLocalStorage('isGovtCustomer');
    if (product.baseProductInfo?.variantInfo?.length) {
      this.productInfo = product.baseProductInfo.variantInfo[product.index];
      this.baseProductName = product.baseProductInfo.name;
      this.prodListSub = this.locStripService.emitSelectedLocs.subscribe(locsData => {
        this.isLocationSelected = !!locsData?.length;
        this.selectedLocations = locsData;
        //RMGP check -may need to move to onInit if doesnt work properly here in method.
        if (locsData && locsData?.length > 0) {   //if there is any selected location
          this.isGovtLocationSelected = this.isGovLocationSelected(true);
          this.cd.detectChanges();
        }
        else {   //no location selected. check for isDefaultLocationGovt flag
          this.isGovtLocationSelected = this.sharedService.getSessionStorage('isDefaultLocationGovt');
          this.cd.detectChanges();
        }
        //this.isGovtLocationSelected = true; //hardcoded for testing

        if (this.userDetails) {
          switch (this.isLocationSelected) {
            case true:
              this.nonFormularyProduct = JSON.parse(localStorage.getItem('formularyCustomer')) ? !this.productInfo.formularyProduct : false;
              this.noYFRestriction = this.productInfo.yellowFever ? JSON.parse(localStorage.getItem('YFAuthorized')) : true;
              if (!this.nonFormularyProduct || this.noYFRestriction) {
                this.buttonName = this.productInfo?.flu === true && this.productInfo?.shipNow === "OFF" ? 'Reserve' : 'Add to Cart';
                if (this.selectedLocations.length == 1) {
                  this.pricingAPI(this.selectedLocations);
                }
                else {
                  this.priceDetails = [];
                  delete this.productInfo['allocationInfos'];
                  this.selectedContractGroup == undefined;
                }

              }
              break;
            default:
              this.buttonName = 'Select a location to order';

          }
          this.cd.detectChanges();
        }
        this.quickOrderDetails = true;
      });
    }
    else {
      this.nonFormularyProduct = false;
      this.noYFRestriction = true;
      this.quickOrderDetails = false;
    }

  }
  pricingAPI(locsData) {
    // Pricing API call

    if (locsData?.length == 1) {
      let req = {
        productCodes: [this.productInfo.code],
        b2bUnitId: locsData[0].accountNumber
      };
      this.plpService.getProductPrices(req).subscribe(prices => {
        if (prices) {
          this.selectedContractGroup = undefined;
          this.priceDetails = prices.priceAndAvailability[0];
          if (this.priceDetails.conditions?.length == 1) {
            this.selectedContractGroup = this.priceDetails?.conditions[0];
            // this.cd.detectChanges();
          }
          this.quickOrderDetails = true;
          if (JSON.parse(sessionStorage.getItem('productAllocations'))) {
            let x = JSON.parse(JSON.stringify(this.productInfo));
            let y = JSON.parse(sessionStorage.getItem('productAllocations'));
            this.productInfo = { ...x, allocationInfos: y[_.findIndex(y, { productCode: this.productInfo.code })] };
            this.productInfo.allocationInfos?.availableQty == '0' && this.performQuantityComputationQuick(null, this.productInfo.code);
          }
          this.cd.detectChanges();
        }
      });
    }
  }
  getContractPrice(data) {
    if (this.priceDetails?.conditions !== undefined) {
      return data !== undefined ? data?.contractPrice?.formattedValue : '$--';
    }
  }
  ngOnDestroy() {
    this.userDataSub?.unsubscribe();
    this.updatedCartDetailsSub?.unsubscribe();
    this.updatedCartSub?.unsubscribe();
    this.allCartsSub?.unsubscribe();
    this.createdCartSub?.unsubscribe();
    this.prodListSub?.unsubscribe();
  }
  cssClassForButton() {
    if (this.buttonName == 'Add to Cart' && this.blockOrder) {
      return 'disable-btn';
    } else {
      if ((this.productInfo.priceInfos?.conditions.length > 1 && !this.selectedContractGroup) ||
        ProductUtils.showLimitationPopoverFor) {
        return 'disable-btn';
      }
      else {
        if (this.buttonName == 'Reserve') {
          return 'reserveBtn enable-btn'
        }
        return 'enable-btn';
      }
    }
  }

  openLimitationModal() {
    let modalRef = this.modal.open(RestrictionPopupComponent, {
      centered: true,
      backdrop: 'static',
      windowClass: `restrictionModal ${this.baseSiteId}`
    });


    modalRef.componentInstance.productDetails = {
      name: this.baseProductName,
      allotted: this.productInfo.allocationInfos.allocatedQty,
      consumed: this.productInfo.allocationInfos.consumedQty,
      available: this.productInfo.allocationInfos.availableQty,
      frequency: this.productInfo.allocationInfos.numberOfDays
    };
  }
  get showLimitPopoverValueFor() {
    return ProductUtils.showLimitationPopoverFor;
  }
  getConditionCheck(data) {
    return !data.unavailable && data.available && data.orderable && !data.discontinued;
  }
  // getButtonCheck(data) {
  //   if (this.isLocationSelected) {
  //     return !data.unavailable && data.available && data.orderable && !data.discontinued
  //   }
  //   return true;
  // }
  isGovLocationSelected(locEmitted?) {
    let selectedLocs;
    let govLocationCounter = 0;
    if (locEmitted) {
      selectedLocs = this.selectedLocations
    }
    else {
      if ('selectedLocations' in sessionStorage) {
        selectedLocs = JSON.parse(sessionStorage.getItem('selectedLocations'));
      }
    }
    selectedLocs?.map(loc => {
      if (loc?.isGovernmentLocation) {
        govLocationCounter++
      }
    });
    if (govLocationCounter > 0) {
      return true;
    }
    return false;
  }

}
